import {useEffect, useState} from 'react'
import SearchableSelect from '../../../../components/SearchableSelect/SearchableSelect'
import {getPanelIzolacijaDropdown} from '../../../../api/panelIzolacija'
import {Option} from '../../../../models/Sektor'

//  Props for the component
interface DropdownProps {
    value?: string | number
    initialValue?: string | number
    onChange?: (name: string, value: any) => void
    errors?: string | undefined
    touched?: boolean
    selectName?: string
}

const PanelIzolacijaDropdown: React.FC<DropdownProps> = ({
                                                             value,
                                                             initialValue,
                                                             onChange,
                                                             errors,
                                                             touched,
                                                             selectName,
                                                         }) => {
    const [PanelIzolacijaDropdown, setPanelIzolacijaDropdown] = useState<Array<Option>>([])
    const internalValue = initialValue ?? null

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getPanelIzolacijaDropdown()
                setPanelIzolacijaDropdown(mapData(response.data))
            } catch (error) {
                console.error('Error fetching dropdown data:', error)
            }
        }
        fetchData()
    }, [])

    const finalValue = value ?? internalValue

    const mapData = (data) => {
        if (!data) {
            return []
        }
        return data.map((item) => ({label: item.naziv, value: item.id.toString()}))
    }

    return (
        <SearchableSelect
            options={PanelIzolacijaDropdown}
            value={finalValue?.toString() ?? ''}
            onChange={onChange!}
            name={selectName ?? 'PanelIzolacijaDropdown'}
            errors={errors}
            placeholder='Odaberi Izolaciju'
            touched={touched}
        />
    )
}

export default PanelIzolacijaDropdown
